import BasePage from '../../components/base-page/base-page';

import type { UiElement } from '../../../shared/ui-element/ui-element';

import './wwdc-landing.scss';

export const ERROR_COLOR = '#ff2c47';
export const VALID_COLOR = '#26262b';

class WwdcLanding extends BasePage {
  ui = {
    form: '.js-wwdc-form',
    emailInput: '.js-wwdc-email-input',
    submitButton: '.js-wwdc-submit-btn',
    successMessageBlock: '.js-wwdc-success-message-block',
    emptyEmailErrorMessage: '.js-wwdc-error-empty-input',
    notEmailErrorMessage: '.js-wwdc-error-not-email',
    checkBoxErrorMessage: '.js-wwdc-checkbox-error-message',
    checkBox: '.js-wwdc-checkbox',
    checkBoxLabel: '.js-wwdc-checkbox-label',
  };

  uiCollections = {
    formInputs: '.js-wwdc-input',
  };

  events = {
    'submit @ui.form': 'handleFormSubmit',
    'click @ui.submitButton': 'handleFormValidationClick',
  };

  onInit() {
    super.onInit();
  }

  handleEmailInputValidationAndErrors = () => {
    const emailInput = (this.ui.emailInput as unknown as HTMLInputElement);
    const emptyEmailErrorMessage = (this.ui.emptyEmailErrorMessage as unknown as HTMLElement);
    const notEmailErrorMessage = (this.ui.notEmailErrorMessage as unknown as HTMLElement);

    notEmailErrorMessage.style.display = emailInput.reportValidity() ? 'none' : 'inline';

    if (emailInput.value) {
      emptyEmailErrorMessage.style.display = 'none';
    } else {
      emptyEmailErrorMessage.style.display = 'inline';
      notEmailErrorMessage.style.display = 'none';
    }
  };

  updateCheckboxColor = () => {
    const checkBox = (this.ui.checkBox as unknown as HTMLFormElement);
    const checkBoxLabel = (this.ui.checkBoxLabel as unknown as HTMLFormElement);
    const checkBoxErrorMessage = (this.ui.checkBoxErrorMessage as unknown as HTMLElement);

    checkBoxLabel.style.borderColor = checkBox.checked ? VALID_COLOR : ERROR_COLOR;
    checkBoxErrorMessage.style.display = checkBox.checked ? 'none' : 'inline';
  };

  toggleErrorColor = () => {
    const formInputs = (this.uiCollections.formInputs as unknown as HTMLInputElement[]);

    formInputs.forEach((inputElement) => {
      const input = (inputElement as HTMLInputElement);

      input.classList.remove('wwdc-form-block__input-error', 'form-control_light');
      input.classList.add(input.checkValidity() ? 'form-control_light' : 'wwdc-form-block__input-error');
    });
  };

  handleFormValidationClick = () => {
    this.updateCheckboxColor();
    this.handleEmailInputValidationAndErrors();
    this.toggleErrorColor();
  };

  handleTrimInputValue = () => {
    const emailInput = this.ui.emailInput as unknown as HTMLInputElement;
    emailInput.value = emailInput.value.trim();
  };

  handleFormSubmit = () => {
    const form = (this.ui.form as unknown as HTMLFormElement);
    const successMessageBlock = (this.ui.successMessageBlock as unknown as HTMLElement);

    this.handleTrimInputValue();

    successMessageBlock.style.display = 'flex';
    form.style.display = 'none';
  };
}

export default WwdcLanding;

(WwdcLanding as UiElement).initOnDomLoaded();
